import http, { expandURI } from '@/utils/ajax'
import { extractMenu, extractFullMessages } from '@/utils/extract'
import { AGENCY_QUOTATION_INIT_LOADING, AGENCY_QUOTATION_INIT_SUCCESS, AGENCY_QUOTATION_INIT_FAIL, QUOTE_PACKAGE_PARAM, QUOTE_PACKAGE_GENERAL, QUOTE_PACKAGE_ADJ_CANCEL, QUOTE_PACKAGE_PARAM_PLAN_LOADING, QUOTE_PACKAGE_PARAM_PLAN_SUCCESS, QUOTE_PACKAGE_PARAM_PLAN_FAIL, QUOTE_PACKAGE_RECALCULATE_LOADING, QUOTE_PACKAGE_RECALCULATE_SUCCESS, QUOTE_PACKAGE_RECALCULATE_FAIL } from '@/store/types'

export const pkg = {
  async packageQuoteInit({ commit, state }) {
    const expand = {
      intermediary: state.quotation.commonForm.intermediary
    }
    const apiUrl = expandURI(state.quotationSettings.menu.package, expand)
    if (apiUrl) {
      commit(AGENCY_QUOTATION_INIT_LOADING)
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = result.data
        Object.assign(commitResult, {
          menu: menu
        })
        commit(AGENCY_QUOTATION_INIT_SUCCESS, commitResult)
        if (commitResult.hasContent) {
          commit(QUOTE_PACKAGE_PARAM, commitResult.data)
        }
      } catch (error) {
        commit(AGENCY_QUOTATION_INIT_FAIL)
      }
    } else {
      commit(AGENCY_QUOTATION_INIT_FAIL, ['Invalid API URL'])
    }
  },
  async packageQuoteGeneral({ commit, state }, data) {
    // Before committing the data, we will check what is affected by the change of packageQuoteGeneral fields
    const commonForm = state.quotation.commonForm

    // Check if there is a change of scheme
    if (!commonForm.scheme || commonForm.scheme !== data.scheme) {
      // Need clear out plan here
      commit(QUOTE_PACKAGE_ADJ_CANCEL)
    }

    // Check if there is a change of disc/comm fields (promotions)
    if (!commonForm.promotion || commonForm.promotion !== data.promotion) {
      commit(QUOTE_PACKAGE_RECALCULATE_LOADING)
    }
    commit(QUOTE_PACKAGE_GENERAL, data)
  },
  async packageQuotePlans({ commit, state }) {
    const apiUrl = state.quotation.menu.pkgPlans
    if (apiUrl) {
      try {
        commit(QUOTE_PACKAGE_PARAM_PLAN_LOADING)

        const { commonForm } = state.quotation
        const calcForm = {
          appID: commonForm.appID,
          intermediary: commonForm.intermediary,
          product: commonForm.product,
          scheme: commonForm.scheme,
          acceptDate: commonForm.acceptDate,
          startDate: commonForm.startDate,
          endDate: commonForm.endDate,
          campaign: commonForm.campaign,
          promotion: commonForm.promotion
        }
        const result = await http.post(apiUrl, calcForm)
        const { data } = result
        commit(QUOTE_PACKAGE_PARAM_PLAN_SUCCESS, data)
      } catch (error) {
        commit(QUOTE_PACKAGE_PARAM_PLAN_FAIL, extractFullMessages(error))
      }
    } else {
      commit(QUOTE_PACKAGE_PARAM_PLAN_FAIL)
    }
  },
  async packageQuoteRecalculate({ commit, state }) {
    const apiURI = state.quotation.menu.pkgPlanAdj
    if (apiURI) {
      commit(QUOTE_PACKAGE_RECALCULATE_LOADING)
      try {
        const { commonForm, packageForm } = state.quotation

        const calcForm = {
          appID: commonForm.appID,
          intermediary: commonForm.intermediary,
          product: commonForm.product,
          scheme: commonForm.scheme,
          acceptDate: commonForm.acceptDate,
          startDate: commonForm.startDate,
          endDate: commonForm.endDate,
          planNo: packageForm.planNo,
          siAdjustment: packageForm.siAdjustment,
          campaign: commonForm.campaign,
          promotion: commonForm.promotion,
          adjDiscount: commonForm.adjDiscount
        }

        const result = await http.post(apiURI, calcForm)
        if (result.data) {
          const { data } = result
          commit(QUOTE_PACKAGE_RECALCULATE_SUCCESS, data)
        }
      } catch (err) {
        commit(QUOTE_PACKAGE_RECALCULATE_FAIL, extractFullMessages(err))
      }
    } else {
      commit(QUOTE_PACKAGE_RECALCULATE_FAIL, ['Invalid API URL'])
    }
  }
}
